import logo from './logo.svg';
import './App.css';
import HeroSection from './components/HeroSection';
import Vision from './components/VisionMission';
import Cards from './components/Cards';
import Projects from './components/CompletedProjects';
import CustomSlider from './components/Gallery';
import Contact from './components/ContactUs';
import ModalPop from './components/ModalPop';
import OurProjects from './components/OurProjects';
import GurukulSamriddhi from './components/GurukulSamriddhi';



function App() {

  return (
    <>
      {/* <ModalPop /> */}
      <HeroSection />

      {/* <GurukulSamriddhi /> */}
      <OurProjects />
      




      <Cards />

      {/* <Projects /> */}
      <Vision />
      {/* <CustomSlider /> */}
      <Contact />

    </>

  )
}

export default App;
